export default __webpack_public_path__ + "static/media/malalaList.236532a6.png";